/**
 * Update Company Modal — built on TradeForm.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/update-company-modal.liquid via trade-modal.liquid).
 *
 * Populates from window.currentCompanyData on open. If not available,
 * fetches company data async.
 *
 * Exposes:
 *   window.TradeUpdateCompanyModal.open()
 *   window.TradeUpdateCompanyModal.close()
 */
(function () {
	const overlay = document.getElementById('update-details-modal');
	if (!overlay) return;

	const companyNameDisplay = document.getElementById('modal-company-name-display');

	function populateFromCompany(ctrl, companyData) {
		const address = companyData.address || {};
		if (companyNameDisplay) companyNameDisplay.textContent = companyData.name || 'Not set';
		ctrl.setValues({
			admin:    companyData.email || '',
			address1: address.address1 || '',
			address2: address.address2 || '',
			city:     address.city || '',
			state:    address.state || '',
			country:  address.country || 'United States',
			zip:      address.zipPostalCode || '',
		});
	}

	const form = createTradeForm({
		overlay: overlay,
		clearOnClose: false,
		focusOnOpen: null,
		triggerSelector: '[data-open-update-company]',
		submitBtn: 'confirm-update-details-btn',
		resetBtnText: 'Update Details',
		errorContainer: 'update-company-error-message',
		errorText: 'update-company-error-text',
		fields: {
			admin: {
				id: 'modal-company-admin-input',
				required: 'Please enter a valid company admin email.',
				validate: function (v) {
					if (v.indexOf('@') === -1) return 'Please enter a valid company admin email.';
					if (!window.currentCompanyId) return 'Company ID not found. Please refresh the page and try again.';
					return null;
				},
			},
			address1: { id: 'modal-company-address1-input', required: 'Please enter an address.' },
			address2: { id: 'modal-company-address2-input', required: false },
			city:     { id: 'modal-company-city-input',     required: 'Please enter a city.' },
			state:    { id: 'modal-company-state-input',    required: 'Please enter a state.' },
			country:  { id: 'modal-company-country-select', required: false },
			zip:      { id: 'modal-company-zip-input',      required: 'Please enter a ZIP/postal code.' },
		},
		onOpen: function (ctrl) {
			const companyData = window.currentCompanyData;
			if (companyData) {
				populateFromCompany(ctrl, companyData);
			} else {
				tradeFetch(window.tradeApiBase + '/companies', undefined, { source: 'TradeUpdateCompanyModal.fetchCompany' })
					.then(function (resp) { return resp.json(); })
					.then(function (data) {
						if (data.company) {
							window.currentCompanyData = data.company;
							window.currentCompanyId = data.company.id || null;
							populateFromCompany(ctrl, data.company);
						}
					})
					.catch(function (err) {
						console.error('Error fetching company data for modal:', err);
					});
			}
		},
		submit: {
			url: window.tradeApiBase + '/companies',
			method: 'PUT',
			loadingText: 'Updating...',
			source: 'TradeUpdateCompanyModal.updateCompany',
			buildPayload: function (values) {
				return {
					email: values.admin,
					address: {
						address1: values.address1,
						address2: values.address2,
						city: values.city,
						state: values.state,
						country: values.country,
						zipPostalCode: values.zip,
					},
				};
			},
			onSuccess: function (data, ctrl) {
				ctrl.modal.close();
				document.dispatchEvent(new CustomEvent('trade:company-updated'));
			},
			onError: function (err, ctrl) {
				console.error('Error updating company details:', err);
				ctrl.showError('Failed to update company details. Please try again.');
			},
		},
	});

	/* ── public API ── */

	window.TradeUpdateCompanyModal = {
		open: function () { form.modal.open(); },
		close: function () { form.modal.close(); },
	};
})();
